/** @jsxImportSource theme-ui */

import { BepiCategoryDescription } from 'models/BepiModels';
import React from 'react';
import { Typography } from 'components/_common/Typography';

type BepiTooltipContentProps = {
  bepiCategoryDescription: BepiCategoryDescription;
  width?: number;
};

export const BepiTooltipContent: React.FC<BepiTooltipContentProps> = ({
  bepiCategoryDescription,
  width = 400,
}) => {
  return (
    <div
      sx={{
        width: `${width}px`,
      }}
    >
      <Typography variant="subtitle2" color="stone10" marginBottom="8px">
        {bepiCategoryDescription.label} Domain
      </Typography>
      {bepiCategoryDescription.descriptionLines.map((line, index) => (
        <Typography key={index} variant="caption" color="stone10" marginBottom="8px">
          {line}
        </Typography>
      ))}
      <Typography variant="caption2" color="stone10">
        Considered factors include:
      </Typography>
      <Typography variant="caption" color="stone10">
        {bepiCategoryDescription.consideredFactors.map((consideredFactor, index) => (
          <div key={index} sx={{ display: 'flex', alignItems: 'center' }}>
            <div
              sx={{
                mr: '3px',
                width: '3px',
                height: '3px',
                borderRadius: '50%',
                backgroundColor: 'stone10',
              }}
            />
            <div>{consideredFactor}</div>
          </div>
        ))}
      </Typography>
    </div>
  );
};

export default BepiTooltipContent;
